import PropTypes from "prop-types";

import {
  Content,
  SearchField,
  SearchInputStyled,
  ResetSearchButton,
  ResetSearchIcon,
  SearchInputIcon,
} from "pages/Search/components/styles";

const SearchInput = ({ searchTerm, handleOnChange, handleReset }) => {
  return (
    <Content>
      <SearchField>
        <SearchInputIcon fontSize="large" />
        <SearchInputStyled
          type="text"
          value={searchTerm}
          onChange={handleOnChange}
          placeholder="Search"
          autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        />
        <ResetSearchButton color="inherit" aria-label="close" onClick={handleReset} size="large">
          <ResetSearchIcon fontSize="inherit" />
        </ResetSearchButton>
      </SearchField>
    </Content>
  );
};

SearchInput.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
};

export default SearchInput;
